// MeasureRows makes the "Detalle de medidas" table grow.
//
// A request is almost never one window: it is three of one size, two of another,
// sometimes in different materials. The form ships with one row already filled
// in; this adds and removes the rest.
//
// Island Architecture: a light-DOM web component, so every <select>/<input> it
// clones keeps taking part in the surrounding <form> submission. Without JS the
// single server-rendered row still works — that is the floor this stands on.

const MAX_ROWS = 30; // el mismo techo que aplica el servidor

export class MeasureRows extends HTMLElement {
  private list!: HTMLElement;
  private template!: HTMLTemplateElement;
  private addButton!: HTMLButtonElement;

  connectedCallback(): void {
    const list = this.querySelector<HTMLElement>("[data-measure-list]");
    const template = this.querySelector<HTMLTemplateElement>("[data-measure-template]");
    const addButton = this.querySelector<HTMLButtonElement>("[data-measure-add]");
    if (!list || !template || !addButton) return;

    this.list = list;
    this.template = template;
    this.addButton = addButton;

    addButton.addEventListener("click", (): void => this.addRow());

    // Delegated: rows come and go, so binding per row would leak listeners and
    // miss every row added after mount.
    this.list.addEventListener("click", (event: MouseEvent): void => {
      const button = (event.target as HTMLElement | null)?.closest("[data-measure-remove]");
      if (!button) return;
      button.closest("[data-measure-row]")?.remove();
      this.sync();
    });

    this.sync();
  }

  private addRow(): void {
    if (this.rows().length >= MAX_ROWS) return;

    const row = this.template.content.cloneNode(true) as DocumentFragment;
    const added = row.firstElementChild as HTMLElement | null;
    this.list.append(row);
    this.sync();

    // Land the cursor where the customer is going to type anyway: the width of
    // the row they just asked for.
    added?.querySelector<HTMLInputElement>('[name="item_width_cm"]')?.focus();
  }

  private rows(): HTMLElement[] {
    return Array.from(this.list.querySelectorAll<HTMLElement>("[data-measure-row]"));
  }

  /**
   * Keeps the controls honest about what they can do: the last row cannot be
   * removed (a request with no measurements is not a request), and no more rows
   * can be added past the limit the server enforces.
   */
  private sync(): void {
    const rows = this.rows();
    const only = rows.length <= 1;
    for (const row of rows) {
      const remove = row.querySelector<HTMLButtonElement>("[data-measure-remove]");
      if (remove) remove.disabled = only;
    }
    this.addButton.disabled = rows.length >= MAX_ROWS;
  }
}
